<template>
    <WindowDialog
        :is-open="preview.mode === 'floating-play'"
        title="Whiteboard"
        z-index="6000"
        width="500px"
        height="300px"
        hide-close-button="true"
    >
        <img :src="preview.image" class="w-auto object-contain" />
    </WindowDialog>

    <WindowDialog
        :is-open="preview.mode === 'floating-video'"
        :title="preview.video?.title"
        z-index="6000"
        width="500px"
        height="300px"
        hide-close-button="true"
    >
        <video
            style="width: 100%"
            controls
            v-if="preview?.isPlaying"
            autoplay
            class="h-[92%] w-auto"
        >
            <source :src="preview?.video?.url" type="video/mp4" />
        </video>
        <img
            :src="preview.video?.thumbnail"
            class="w-auto object-contain"
            v-else
        />
        <div
            class="
                absolute
                top-[45px]
                left-0
                w-full
                h-full
                flex
                items-center
                justify-center
                text-white
                bg-black/30
                cursor-pointer
            "
            v-show="!preview?.isPlaying"
            v-on:click.stop="play()"
        >
            <ion-icon
                name="play"
                size="lg"
                style="font-size: 4em; margin-bottom: 35px"
            ></ion-icon>
        </div>
    </WindowDialog>
    <div
        v-if="
            preview.mode != 'play-fullscreen' &&
            preview.mode != 'floating-video'
        "
        class="
            w-[calc(100vw-70px)]
            relative
            h-[50vh]
            bg-black
            flex
            justify-center
        "
        :class="{
            '!h-[calc(100vh-60px)]':
                preview.mode === 'floating-play' ||
                preview.mode === 'video-fullscreen',
            hidden: preview.mode === 'floating-video',
        }"
    >
        <scribble-area :key="preview.mode"></scribble-area>
        <video
            style="width: 100%"
            controls
            v-show="preview.isPlaying && preview?.video.isLiveStream"
            autoplay
            class="h-full w-auto"
            id="video-live-stream"
            ref="videoLiveStream"
        ></video>
        <video
            style="width: 100%"
            controls
            v-if="preview?.isPlaying && !preview?.video.isLiveStream"
            autoplay
            class="h-full w-auto"
        >
            <source :src="preview?.video.url" type="video/mp4" />
        </video>

        <img
            :src="preview?.video?.thumbnail"
            class="w-auto h-full object-contain"
            v-else
        />
        <div
            class="
                absolute
                bottom-[10px]
                left-[10px]
                w-full
                h-[50px]
                flex
                items-end
                justify-start
                text-white
                bg-black/30
                cursor-pointer
                z-[1000]
            "
            v-show="!preview.isPlaying"
            v-on:click.stop="play()"
        >
            <ion-icon name="play" size="lg" style="font-size: 2em"></ion-icon>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed, onMounted, reactive, watch, ref } from "vue";
import Hls from "hls.js";
import WindowDialog from "./WindowDialog.vue";
import useWhiteboard from "./whiteboard/useWhiteboard";

const { preview } = useWhiteboard();

// emitter.on("open-stacked-video", async (data) => {
//     state.mode = data.mode;
//     state.isPlaying = false;
//
//     if (data.videoId) {
//         const video = await axios("/video/" + data.videoId);
//         state.video = video.data;
//     }
//
//     if (data.video) {
//         state.video = data.video;
//     }
//
//     if (data.image) {
//         state.image = data.image;
//     }
// });

const videoLiveStream = ref(null);

function play() {
    preview.value.isPlaying = true;

    if (preview.value.video?.isLiveStream) {
        const video = videoLiveStream.value;
        const browserHasNativeHLSSupport = video.canPlayType(
            "application/vnd.apple.mpegurl"
        );
        if (Hls.isSupported()) {
            let hls = new Hls();
            hls.loadSource(preview.value.video.url);
            hls.attachMedia(video);
            video.play();
        } else if (browserHasNativeHLSSupport) {
            console.log("hls unsupported");
            video.src = hlsUrl;
        }
    }
}
</script>
